export default __webpack_public_path__ + "static/media/postanovlenie.763042be.pdf";